import React, { useState } from 'react';
import { Typography, Steps, Skeleton } from 'antd';
import get from 'lodash/get';
import assign from 'lodash/assign';
import { RightOutlined } from '@ant-design/icons';
import ContentPageHeader from '../../../components/contentPageHeader';
import SelectChannel from './SelectChannel';
import CampaignDetails from './CampaignDetails';
import FurtherCriteriaDetails from './FurtherCriteriaDetails';
import BrandCriteriaDetails from './BrandCritera';
import ReviewCampaignDetails from './ReviewCampaignDetails';

const { Text } = Typography;

const CreateCampaignScreen = () => {
  const edit = false;
  const [loading] = useState(false);
  const [showFurtherSteps, setShowFurtherSteps] = useState(false);
  const [payload, setPayload] = useState({
    step: 0,
    step1: null,
    step2: null,
    step3: null,
    step4: null,
  });
  const onSubmitPayload = (currentStep, obj = {}) => {
    let key = null;
    let step = null;
    switch (currentStep) {
      case 0:
        key = 'step1';
        step = currentStep + 1;
        break;
      case 1:
        key = 'step2';
        if (get(obj, 'type') === 'SAMPLE') {
          setShowFurtherSteps(true);
          step = currentStep + 1;
        } else {
          setShowFurtherSteps(false);
          assign(payload, {
            step3: null,
            step4: null,
          });
          step = 4;
        }
        break;
      case 2:
        key = 'step3';
        step = currentStep + 1;
        break;
      case 3:
        key = 'step4';
        step = currentStep + 1;
        break;
      default:
        key = null;
        break;
    }
    assign(payload, { [key]: obj, step });
    setPayload({ ...payload });
  };
  const onMove = (step) => {
    setPayload({ ...payload, step });
  };

  return (
    <div>
      <div>
        <ContentPageHeader
          title={[
            <Text className="content-page-header-heading">Campaign List</Text>,
            <RightOutlined className="content-page-header-heading" />,
            <Text className="content-page-header-heading">
              {edit ? 'Edit Campaign' : 'Add New Campaign'}
            </Text>,
          ]}
          extra={[]}
        />
        <div className="create-product-stepper">
          <Steps
            labelPlacement="vertical"
            size="small"
            current={get(payload, 'step')}
            onChange={(value) => {
              setPayload({
                ...payload,
                step:
                  get(payload, 'step') > value ? value : get(payload, 'step'),
              });
            }}
            items={[
              {
                title: 'Sales Channel',
              },
              {
                title: 'Details Required',
              },
              showFurtherSteps
                ? {
                    title: 'Further Criteria',
                  }
                : undefined,
              showFurtherSteps
                ? {
                    title: 'Brand Criteria',
                  }
                : undefined,
              {
                title: 'Review',
              },
            ]}
          />
        </div>
        <div className="create-product-form-container">
          <Skeleton loading={loading}>
            {get(payload, 'step') === 0 && (
              <SelectChannel
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step1')}
              />
            )}
            {get(payload, 'step') === 1 && (
              <CampaignDetails
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step2')}
                salesChannel={get(payload, 'step1')}
              />
            )}
            {get(payload, 'step') === 2 && showFurtherSteps && (
              <FurtherCriteriaDetails
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step3')}
              />
            )}

            {get(payload, 'step') === 3 && showFurtherSteps && (
              <BrandCriteriaDetails
                onMove={onMove}
                onSubmitPayload={onSubmitPayload}
                initialValues={get(payload, 'step4')}
              />
            )}

            {get(payload, 'step') === 4 && (
              <ReviewCampaignDetails
                onMove={onMove}
                showFurtherSteps={showFurtherSteps}
                onSubmitPayload={onSubmitPayload}
                details={payload}
              />
            )}
          </Skeleton>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaignScreen;
